import * as React from 'react'
import Icon from 'react-fa';

class Load extends React.Component< any,any> {
	constructor(props) {
		super(props)
		this.state = this.newLoadingState(props)
	}

	newLoadingState(props) {
		return {
			loading: props.loading,
			startTime: Date.now()
		}
	}

	stopLoadingIfDone(props=this.props) {
		const { loading, startTime } = this.state
		if (props.loading) {
			if (!loading) this.setState(this.newLoadingState(props))
			return
		}

		if (!loading) return // nothingTodo
		const remainingTime = 1000 - Date.now() - startTime
		if (remainingTime > 0) return setTimeout(() => this.stopLoadingIfDone(props), remainingTime)

		this.setState({loading: false})
	}

	componentWillUpdate(nextProps) {
		this.stopLoadingIfDone(nextProps)
	}

	render() {
		const { loading, startTime } = this.state
		const { children, className, style, text='Loading ...' } = this.props

		if (!loading) return <div style={style} className={className}>{children}</div>
return (
<div style={style} className={className}>
	<Icon spin name="spinner" /> {text}
</div>
)
	}
}

export default Load



// WEBPACK FOOTER //
// ./src/app/components/Load/index.tsx